import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './ShieldLock.module.scss';

const ShieldLock: FC<ShieldLockProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.shieldLock, className]}
      viewBox="1291.123 955.928 2548.108 3088.144"
      {...rest}
    >
      <g>
        <path
          className={styles.cls1}
          d="M3788.18,2660.32V1321.81c0-32.85-19.52-62.56-49.67-75.59c-372.91-161.26-767.99-243.02-1174.27-243.02 s-801.36,81.76-1174.27,243.02c-30.15,13.04-49.67,42.75-49.67,75.59v1338.52c-2.96,71.88,23.28,244.95,140.67,450.67 c84.59,148.23,203.41,293.07,353.14,430.49c184.56,169.38,417.34,328.31,691.85,472.37c11.98,6.29,25.12,9.43,38.27,9.43 s26.29-3.14,38.27-9.43c274.52-144.06,507.29-302.99,691.85-472.37c149.74-137.42,268.55-282.26,353.14-430.49 C3764.9,2905.28,3791.14,2732.21,3788.18,2660.32z M3504.45,3029.35c-76.13,133.42-184.29,264.89-321.46,390.77 c-165.52,151.91-373.53,295.62-618.75,427.54c-240.67-129.47-445.59-270.36-609.54-419.13 c-136.85-124.17-245.49-253.97-322.91-385.79c-127.48-217.04-126.99-368.37-126.85-376.64c0.11-1.59,0.08-2.1,0.08-3.88V1376.48 c337.49-138.43,693.55-208.57,1059.22-208.57s721.73,70.14,1059.22,208.57v1285.74c0,1.42,0.04,2.84,0.11,4.26 C3623.65,2667.89,3627.45,2813.8,3504.45,3029.35z"
        />
        <g>
          <path
            className={styles.cls1}
            d="M3042.37,2210.63h-62.21v-255.12c0-231.61-188.42-420.04-420.03-420.04s-420.03,188.43-420.03,420.04v255.12 h-53.98c-45.48,0-82.36,36.87-82.36,82.36v795.67c0,45.48,36.87,82.36,82.36,82.36h956.26c45.48,0,82.36-36.87,82.36-82.36 v-795.67C3124.73,2247.5,3087.85,2210.63,3042.37,2210.63z M2304.81,1955.51c0-140.78,114.54-255.31,255.32-255.31 s255.32,114.53,255.32,255.31v255.12h-510.63V1955.51z M2960.01,3006.3h-791.54v-630.95h791.54V3006.3z"
          />
          <path
            className={styles.cls1}
            d="M2508.09,2737.39v79.72c0,31.01,25.14,56.15,56.15,56.15c31.01,0,56.15-25.14,56.15-56.15v-79.72 c44.17-21.06,74.78-66.14,74.78-118.25c0-72.19-58.73-130.93-130.93-130.93c-72.2,0-130.93,58.73-130.93,130.93 C2433.31,2671.24,2463.92,2716.33,2508.09,2737.39z"
          />
        </g>
      </g>
    </Svg>
  );
};

type ShieldLockProps = {
  className?: string;
};

export default ShieldLock;
